import { useMemo } from 'react';
import type { ProductOrderItem } from '../data/product-order-item';

export const useMaxDeals = (orderItems: ProductOrderItem[]) => {
  return useMemo(() => {
    let max = 0;
    for (const orderItem of orderItems) {
      const tiers = orderItem.product.pricing?.volume_discounts?.length ?? 0;
      if (tiers > max) {
        max = tiers;
      }
    }

    return max;
  }, [orderItems]);
};
